import React from "react";
import Meta from "../components/settings/Meta";
import DashboardLayout from "../components/dashboard/DashboardLayout"; // Import DashboardLayout
import { requireAuth } from "./../util/auth";

function DashboardPage(props) {
  return (
    <>
      <Meta title="Dashboard" />
      <DashboardLayout>
      </DashboardLayout>
    </>
  );
}

export default requireAuth(DashboardPage);
